import React from 'react'
import { Container } from 'react-bootstrap'
import { BRAND } from '../constants/appConstants'

const isToyota = (brand) => brand === BRAND.TOYOTA

const getCategoriesTitle = (brand) => {
	return isToyota(brand) ?
		'Veelbekeken vragen per onderwerp' :
		'Antwoorden per onderwerp'
}

const Category = ({ brand, item }) => {
	return (
		<div className="col-sm-6 col-lg-4">
			<h3>
				<a href={`/${item.nodeId}`}>{item.displayText}</a>
			</h3>
			{item.children && (
				<ul>
					{item.children.map((child) => {
						return (
							<li key={child.nodeId}>
								<a href={`/${child.nodeId}`}>{child.displayText} {isToyota(brand) && (<i className="dxp-icon icon-Arrow_Right-small"></i>)}</a>
							</li>
						)
					})}
				</ul>
			)}
		</div>
	)
}

const Categories = ({ brand, items }) => {
	const categoriesTitle = getCategoriesTitle(brand)

	return (
		<section className="block-section categories">
			<Container>
				<h2 className="h1">{categoriesTitle}</h2>
				{!items && <div className="loading">Bezig met laden..</div>}
				{items && (
					<div className="row">
						{items.map((item) => (
							<Category brand={brand} key={item.nodeId} item={item} />
						))}
					</div>
				)}
			</Container>
		</section>
	)
}

export default Categories
